// import _ from "lodash"
import rulesHandler from '@/services/rulesHandler';

import filter from 'lodash/filter';
import forEachLodash from 'lodash/forEach';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import has from 'lodash/has';
import groupBy from 'lodash/groupBy';

async function refactorDetail(data, rules, producer, onlyManager, source) {
  const eventObj = data.events;
  const sportObj = data.events.sport;
  const categoryObj = data.events.category;
  const tournamentObj = data.events.tournament;
  const marketObj = data.settings;
  const sourceObj = data.events.source;
  const periods = data.periods ? data.periods : [];

  const tree_structure = {
    sport: sportObj.id,
    category: categoryObj.id,
    tournament: tournamentObj.id
  };
  tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
    tree_structure,
    rules,
    onlyManager,
    producer
  );

  const sport_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      sportObj,
      rules,
      onlyManager,
      sportObj.id
    );
    resolve(result);
  });

  const category_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      categoryObj,
      rules,
      onlyManager,
      categoryObj.id
    );
    resolve(result);
  });

  const tournament_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      tournamentObj,
      rules,
      onlyManager,
      tournamentObj.id
    );
    resolve(result);
  });

  const event_promise = new Promise(async (resolve, reject) => {
    const result = await refactorEventDetailOdds(
      eventObj,
      rules,
      onlyManager,
      tree_structure,
      producer,
      periods
    );
    resolve(result);
  });

  const markets_group_promise = new Promise(async (resolve, reject) => {
    const result = await refactorGroupMarkets(marketObj, rules.lang);
    resolve(result);
  });

  const responsePromises = await Promise.all([
    sport_promise,
    category_promise,
    tournament_promise,
    event_promise,
    markets_group_promise
  ]);

  return {
    sport: {
      ...responsePromises[0]
    },
    category: {
      ...responsePromises[1]
    },
    tournament: {
      ...responsePromises[2]
    },
    event: {
      ...responsePromises[3].events[0]
    },
    event_sources: {
      ...responsePromises[3].events_sources[0]
    },
    groupMarkets: {
      ...responsePromises[4]
    },
    source: source,
    sourceStatscore: sourceObj[0].value
  };
}

async function refactorOddsDetail(data, rules, producer, onlyManager, source) {
  const eventObj = data.events;
  const sportObj = data.tournament[0].sport_detail;
  const categoryObj = data.tournament[0].category_detail;
  const tournamentObj = data.tournament[0];

  const tree_structure = {
    sport: sportObj.source,
    category: categoryObj.source,
    tournament: tournamentObj.source
  };

  tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
    tree_structure,
    rules,
    onlyManager,
    producer
  );

  const event_promise = new Promise(async (resolve, reject) => {
    const result = await refactorEventDetailOdds(
      eventObj,
      rules,
      onlyManager,
      tree_structure,
      producer
    );
    resolve(result);
  });

  const responsePromises = await Promise.all([event_promise]);

  return {
    event: {
      ...responsePromises[0].events[0]
    }
  };
}

// async function refactorLive(data, rules, producer, onlyManager, source) {
//
//     var eventsCollections = data.events;
//
//     var first = _.first(data.events);
//     var sportObj
//     var categoryObj
//     var tournamentObj
//
//     if (hasIn(first, 'resource')) {
//         var filterSportFirst = find(first.resource, {type: "sport"})
//
//         var idS1
//         if (filterSportFirst) {
//             sportObj = filterSportFirst.data
//             idS1 = _.split(sportObj.source, ':');
//             _.assign(sportObj,{id:idS1[2]})
//         } else {
//             var idT = _.split(first.sport, ':');
//             sportObj = {
//                 "id": idT[2],
//                 "source": first.sport,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.sport
//                 }]
//             }
//         }
//         var idC1
//         var filterCategoryFirst = find(first.resource, {type: "category"})
//         if (filterCategoryFirst) {
//             categoryObj = filterCategoryFirst.data
//             idC1 = _.split(categoryObj.source, ':');
//             _.assign(categoryObj,{id:idC1[2]})
//         } else {
//             var id = _.split(first.category, ':');
//             categoryObj = {
//                 "id": id[2],
//                 "source": first.category,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.category
//                 }]
//             }
//         }
//
//         var idT1
//         var filterTournamentFirst = find(first.resource, {type: "tournament"})
//         if (filterTournamentFirst) {
//             tournamentObj = filterTournamentFirst.data
//             idT1 = _.split(tournamentObj.source, ':');
//             _.assign(tournamentObj,{id:idT1[2]})
//         } else {
//             var id = _.split(first.tournament, ':');
//             tournamentObj = {
//                 "id": id[2],
//                 "source": first.tournament,
//                 "detail": [{
//                     "lang": "en",
//                     "text": first.tournament
//                 }]
//             }
//         }
//
//     } else {
//         var idS = _.split(first.sport, ':');
//         sportObj = {
//             "id": idS[2],
//             "source": first.sport,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.sport
//             }]
//         }
//         var idC = _.split(first.category, ':');
//         categoryObj = {
//             "id": idC[2],
//             "source": first.category,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.category
//             }]
//         }
//         var idT = _.split(first.tournament, ':');
//         tournamentObj = {
//             "id": idT[2],
//             "source": first.tournament,
//             "detail": [{
//                 "lang": "en",
//                 "text": first.tournament
//             }]
//         }
//     }
//
//     //var sportObj = data.tournament[0].sport_detail;
//
//     //var sportObj = data.tournament[0].sport_detail;
//     //var categoryObj = data.tournament[0].category_detail;
//     //var tournamentObj = data.tournament[0];
//     //var tournamentObj = {
//     //     "source": "sr:tournament:2949",
//     //     "detail": [ {
//     //         "lang": "en",
//     //         "text": this.source
//     //     } ]
//
//     // };
//     var marketObj = data.settings;
//
//     var tree_structure = {
//         sport: sportObj.source,
//         category: categoryObj.source,
//         tournament: tournamentObj.source
//     }
//
//     tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(tree_structure, rules, onlyManager, producer)
//
//     var sport_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(sportObj, rules, onlyManager, sportObj.source);
//         resolve(result)
//     });
//
//     var category_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(categoryObj, rules, onlyManager, categoryObj.source);
//         resolve(result)
//     });
//
//     var tournament_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorElement(tournamentObj, rules, onlyManager, tournamentObj.source);
//         resolve(result)
//     });
//
//     var events_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorEventsOdds(eventsCollections, rules, onlyManager, tree_structure, producer);
//         resolve(result)
//     });
//
//     var markets_promise = new Promise(async (resolve, reject) => {
//         let result = await refactorMarkets(marketObj, rules.lang);
//         resolve(result)
//     });
//
//
//     const responsePromises = await Promise.all([sport_promise, category_promise, tournament_promise, events_promise, markets_promise])
//
//     return {
//         sport: {
//             ...responsePromises[0]
//         },
//         category: {
//             ...responsePromises[1]
//         },
//         tournament: {
//             ...responsePromises[2]
//         },
//         events: {
//             ...responsePromises[3].events
//         },
//         events_sources: [
//             ...responsePromises[3].events_sources
//         ],
//         markets: {
//             ...responsePromises[4]
//         },
//         markets_count:
//         Object.keys(responsePromises[4]).length
//         ,
//         message: {
//             num_events: eventsCollections.length
//         },
//         source: source,
//         type: 'prematch'
//     }
//
// }

/* async function refactorLive(
  dataAll,
  rules,
  producer,
  onlyManager,
  group = true
) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = find(dataAll, { selected: true });

      // eliminare i disabled

      const eventsObj = data.events;
      const marketsObj = data.settings;

      const promise = [];

      forEachLodash(eventsObj, async event => {
        promise.push(
          this.refactorSingleLive(
            event,
            rules,
            producer,
            onlyManager,
            marketsObj
          )
        );
      });

      const refactored = [];
      await Promise.all(promise).then(result => {
        const clean_events = filter(result, function (o) {
          return (
            o.category.status != false &&
            o.tournament.status != false &&
            o != false
          );
        });

        if (clean_events.length == 0) {
          resolve(clean_events);
        }

        if (group) {
          const groupedByTournament = groupBy(clean_events, obj => {
            return obj.tournament.id;
          });

          forEachLodash(groupedByTournament, (tourn, index) => {
            const events = [];
            const events_sources = [];

            forEachLodash(tourn, event => {
              events.push(event.events[0]);
              events_sources.push(event.events_sources[0]);
            });

            const events_ordered = orderBy(events, ['time'], ['asc']);

            const object = {
              category: tourn[0].category,
              markets: tourn[0].markets,
              markets_count: tourn[0].markets_count,
              sport: tourn[0].sport,
              tournament: tourn[0].tournament,
              type: tourn[0].type,
              events: events_ordered,
              events_sources: events_sources,
              events_count: events_sources.length,
              categoryOrder:
                tourn[0].categoryOrder != null ? tourn[0].categoryOrder : 9999,
              tournamentOrder:
                tourn[0].tournamentOrder != null
                  ? tourn[0].tournamentOrder
                  : 9999
            };

            refactored.push(object);
          });
          resolve(refactored);
        } else {
          resolve(clean_events);
        }
      });
    } catch (e) {
      console.log(e);
    }
  });
} */


async function refactorLive(
    dataAll,
    rules,
    producer,
    onlyManager,
    group = true
) {
    try {
        const data = find(dataAll, { selected: true })

        if (!data || !data.events || !data.settings) {
            return []
        }

        const eventsObj = data.events
        const marketsObj = data.settings

        const promises = eventsObj.map(event =>
            this.refactorSingleLive(
                event,
                rules,
                producer,
                onlyManager,
                marketsObj
            )
        )

        const results = await Promise.all(promises)

        const cleanEvents = results.filter(o =>
            o &&
            o.category?.status !== false &&
            o.tournament?.status !== false
        )

        if (!group) {
            return cleanEvents
        }

        const groupedByTournament = groupBy(
            cleanEvents,
            o => o.tournament.id
        )

        const refactored = Object.values(groupedByTournament).map(tourn => {
            const events = tourn
                .map(e => e.events?.[0])
                .filter(Boolean)

            const eventsSources = tourn
                .map(e => e.events_sources?.[0])
                .filter(Boolean)

            return {
                category: tourn[0].category,
                markets: tourn[0].markets,
                markets_count: tourn[0].markets_count,
                sport: tourn[0].sport,
                tournament: tourn[0].tournament,
                type: tourn[0].type,
                events: orderBy(events, ['time'], ['asc']),
                events_sources: eventsSources,
                events_count: eventsSources.length,
                categoryOrder: tourn[0].categoryOrder ?? 9999,
                tournamentOrder: tourn[0].tournamentOrder ?? 9999
            }
        })

        return refactored

    } catch (e) {
        console.error('refactorLive error:', e)
        return []
    }
}

  async function refactorSingleLive(
  event,
  rules,
  producer,
  onlyManager,
  marketsObj
) {
  return new Promise(async (resolve, reject) => {
    try {
      const sportObj = event.sport;
      const categoryObj = event.category;
      const tournamentObj = event.tournament;
      const eventsCollections = [event];

      const tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
      };

      tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
        tree_structure,
        rules,
        onlyManager,
        producer
      );

      const sport_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          sportObj,
          rules,
          onlyManager,
          sportObj.id
        );
        resolve(result);
      });

      const category_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          categoryObj,
          rules,
          onlyManager,
          categoryObj.id
        );
        resolve(result);
      });

      const tournament_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          tournamentObj,
          rules,
          onlyManager,
          tournamentObj.id
        );
        resolve(result);
      });

      const events_promise = new Promise(async (resolve, reject) => {
        const result = await refactorEventsOdds(
          eventsCollections,
          rules,
          onlyManager,
          tree_structure,
          producer
        );
        resolve(result);
      });

      const markets_promise = new Promise(async (resolve, reject) => {
        const result = await refactorMarkets(marketsObj, rules.lang);
        resolve(result);
      });

      const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        events_promise,
        markets_promise
      ]);

      const result = {
        sport: {
          ...responsePromises[0]
        },
        category: {
          ...responsePromises[1]
        },
        tournament: {
          ...responsePromises[2]
        },
        events: {
          ...responsePromises[3].events
        },
        events_sources: [...responsePromises[3].events_sources],
        markets: {
          ...responsePromises[4]
        },
        markets_count: Object.keys(responsePromises[4]).length,
        type: 'live',
        categoryOrder: event.categoryOrder || 9999,
        tournamentOrder: event.tournamentOrder || 9999
      };
      resolve(result);
    } catch (e) {
      console.log(e);
      resolve(false);
    }
  });
}

async function refactorSingleNextEvent(
  event,
  rules,
  producer,
  onlyManager,
  marketsObj
) {
  return new Promise(async (resolve, reject) => {
    try {
      const sportObj = event.sport;
      const categoryObj = event.category;
      const tournamentObj = event.tournament;
      const eventsCollections = [event];

      const tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
      };

      tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
        tree_structure,
        rules,
        onlyManager,
        producer
      );

      const sport_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          sportObj,
          rules,
          onlyManager,
          sportObj.id
        );
        resolve(result);
      });

      const category_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          categoryObj,
          rules,
          onlyManager,
          categoryObj.id
        );
        resolve(result);
      });

      const tournament_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          tournamentObj,
          rules,
          onlyManager,
          tournamentObj.id
        );
        resolve(result);
      });

      const events_promise = new Promise(async (resolve, reject) => {
        const result = await refactorEventsOdds(
          eventsCollections,
          rules,
          onlyManager,
          tree_structure,
          producer
        );
        resolve(result);
      });

      const markets_promise = new Promise(async (resolve, reject) => {
        const result = await refactorMarkets(marketsObj, rules.lang);
        resolve(result);
      });

      const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        events_promise,
        markets_promise
      ]);

      const result = {
        sport: {
          ...responsePromises[0]
        },
        category: {
          ...responsePromises[1]
        },
        tournament: {
          ...responsePromises[2]
        },
        events: {
          ...responsePromises[3].events
        },
        events_sources: [...responsePromises[3].events_sources],
        markets: {
          ...responsePromises[4]
        },
        markets_count: Object.keys(responsePromises[4]).length,
        type: 'prematch'
      };

      resolve(result);
    } catch (e) {
      console.log(e);
      resolve(false);
    }
  });
}

async function refactorSingleEventDay(
  event,
  rules,
  producer,
  onlyManager,
  marketsObj,
  headerSign = null
) {
  return new Promise(async (resolve, reject) => {
    try {
      const sportObj = event.sport;
      const categoryObj = event.category;
      const tournamentObj = event.tournament;
      const eventsCollections = [event];

      const tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
      };
      // console.log("tree_structure",tree_structure)
      tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
        tree_structure,
        rules,
        onlyManager,
        producer
      );

      const sport_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          sportObj,
          rules,
          onlyManager,
          sportObj.id
        );
        resolve(result);
      });

      const category_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          categoryObj,
          rules,
          onlyManager,
          categoryObj.id
        );
        resolve(result);
      });

      const tournament_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          tournamentObj,
          rules,
          onlyManager,
          tournamentObj.id
        );
        resolve(result);
      });

      const events_promise = new Promise(async (resolve, reject) => {
        const result = await refactorEventsOdds(
          eventsCollections,
          rules,
          onlyManager,
          tree_structure,
          producer
        );
        resolve(result);
      });

      const markets_promise = new Promise(async (resolve, reject) => {
        const result = await refactorMarkets(marketsObj, rules.lang);
        resolve(result);
      });

      const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        events_promise,
        markets_promise
      ]);

      const result = {
        sport: {
          ...responsePromises[0]
        },
        category: {
          ...responsePromises[1]
        },
        tournament: {
          ...responsePromises[2]
        },
        events: {
          ...responsePromises[3].events
        },
        events_sources: [...responsePromises[3].events_sources],
        markets: {
          ...responsePromises[4]
        },
        markets_count: Object.keys(responsePromises[4]).length,
        type: 'prematch',
        headerSign: headerSign
      };

      resolve(result);
    } catch (e) {
      //debugger

      console.log(e);
      resolve(false);
    }
  });
}

async function refactorSingleEventsBestPlayed(
  event,
  rules,
  producer,
  onlyManager,
  marketsObj,
  headerSign = null
) {
  return new Promise(async (resolve, reject) => {
    try {
      const sportObj = event.sport;
      const categoryObj = event.category;
      const tournamentObj = event.tournament;
      const eventsCollections = [event];

      const tree_structure = {
        sport: sportObj.id,
        category: categoryObj.id,
        tournament: tournamentObj.id
      };

      tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
        tree_structure,
        rules,
        onlyManager,
        producer
      );

      const sport_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          sportObj,
          rules,
          onlyManager,
          sportObj.id
        );
        resolve(result);
      });

      const category_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          categoryObj,
          rules,
          onlyManager,
          categoryObj.id
        );
        resolve(result);
      });

      const tournament_promise = new Promise(async (resolve, reject) => {
        const result = await refactorElement(
          tournamentObj,
          rules,
          onlyManager,
          tournamentObj.id
        );
        resolve(result);
      });

      const events_promise = new Promise(async (resolve, reject) => {
        const result = await refactorEventsOdds(
          eventsCollections,
          rules,
          onlyManager,
          tree_structure,
          producer
        );
        resolve(result);
      });

      const markets_promise = new Promise(async (resolve, reject) => {
        const result = await refactorMarkets(marketsObj, rules.lang);
        resolve(result);
      });

      const responsePromises = await Promise.all([
        sport_promise,
        category_promise,
        tournament_promise,
        events_promise,
        markets_promise
      ]);

      const result = {
        sport: {
          ...responsePromises[0]
        },
        category: {
          ...responsePromises[1]
        },
        tournament: {
          ...responsePromises[2]
        },
        events: {
          ...responsePromises[3].events
        },
        events_sources: [...responsePromises[3].events_sources],
        markets: {
          ...responsePromises[4]
        },
        markets_count: Object.keys(responsePromises[4]).length,
        type: 'prematch',
        headerSign: headerSign
      };

      resolve(result);
    } catch (e) {
      console.log(e);
      resolve(false);
    }
  });
}

async function refactorPreview(data, rules, producer, onlyManager, source) {
  const eventsCollections = data.events;
  const sportObj = data.tournament[0].sport_detail;
  const categoryObj = data.tournament[0].category_detail;
  const tournamentObj = data.tournament[0];
  const marketObj = data.settings;
  const market_header = data.market_header != null ? data.market_header : null; //todo check if needed
  const market_subheader =
    data.market_subheader != null ? data.market_subheader : null; //todo check if needed
  const headerSign = data.headerSign != null ? data.headerSign : null;

  const tree_structure = {
    sport: sportObj.id,
    category: categoryObj.id,
    tournament: tournamentObj.id
  };

  tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
    tree_structure,
    rules,
    onlyManager,
    producer
  );

  const sport_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      sportObj,
      rules,
      onlyManager,
      sportObj.id
    );
    resolve(result);
  });

  const category_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      categoryObj,
      rules,
      onlyManager,
      categoryObj.id
    );
    resolve(result);
  });

  const tournament_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      tournamentObj,
      rules,
      onlyManager,
      tournamentObj.id
    );
    resolve(result);
  });

  const events_promise = new Promise(async (resolve, reject) => {
    const result = await refactorEventsOdds(
      eventsCollections,
      rules,
      onlyManager,
      tree_structure,
      producer
    );
    resolve(result);
  });

  const markets_promise = new Promise(async (resolve, reject) => {
    const result = await refactorMarkets(marketObj, rules.lang);
    resolve(result);
  });

  const responsePromises = await Promise.all([
    sport_promise,
    category_promise,
    tournament_promise,
    events_promise,
    markets_promise
  ]);

  return {
    sport: {
      ...responsePromises[0]
    },
    category: {
      ...responsePromises[1]
    },
    tournament: {
      ...responsePromises[2]
    },
    events: {
      ...responsePromises[3].events
    },
    events_sources: [...responsePromises[3].events_sources],
    markets: {
      ...responsePromises[4]
    },
    markets_count: Object.keys(responsePromises[4]).length,
    message: {
      num_events: eventsCollections.length
    },
    source: source,
    type: 'prematch',
    market_header: market_header, //todo check if needed
    market_subheader: market_subheader, //todo check if needed
    headerSign: headerSign
  };
}

async function refactorPreviewAntepost(
  data,
  rules,
  producer,
  onlyManager,
  source
) {
  const eventDetail = data.events[0];
  const sportObj = data.events[0].sport;
  const categoryObj = data.events[0].category;
  var tournamentObj = data.events[0].tournament;
  const fixtureExtraData = data.events[0].FixtureExtraData;

  const tree_structure = {
    sport: sportObj.id,
    category: categoryObj.id,
    tournament: tournamentObj.id
  };

  tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
    tree_structure,
    rules,
    onlyManager,
    producer
  );

  const sport_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      sportObj,
      rules,
      onlyManager,
      sportObj.id
    );
    resolve(result);
  });

  const category_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      categoryObj,
      rules,
      onlyManager,
      categoryObj.id
    );
    resolve(result);
  });

  const tournament_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      tournamentObj,
      rules,
      onlyManager,
      tournamentObj.id
    );
    resolve(result);
  });

  // var event_desc_promise = new Promise(async (resolve, reject) => {
  //     let result = await refactorElement(eventDetail, rules, onlyManager, eventDetail.id);
  //     resolve(result)
  // });

  // var event_parent_promise = new Promise(async (resolve, reject) => {
  //     if (eventDetail.parent != undefined) {
  //         let result = await refactorElement(eventDetail.parent, rules, onlyManager, eventDetail.parent.source);
  //         resolve(result)
  //     } else {
  //         resolve(null)
  //     }
  //
  // });

  const events_promise = new Promise(async (resolve, reject) => {
    const result = await refactorEventsAntepostOdds(
      eventDetail,
      rules,
      onlyManager,
      tree_structure,
      producer
    );
    resolve(result);
  });

  // var markets_promise = new Promise(async (resolve, reject) => {
  //     let result = await refactorMarkets(marketObj, rules.lang);
  //     resolve(result)
  // });

  const responsePromises = await Promise.all([
    sport_promise,
    category_promise,
    tournament_promise,
    events_promise
  ]);
  //
  // if (!hybridSports.includes(sportObj.source)) {
  //     responsePromises[0].name = 'Antepost ' + responsePromises[0].name
  // }

  var tournamentObj = {
    ...responsePromises[2]
  };

  if (fixtureExtraData) {
    const raceTitle = find(fixtureExtraData, { Name: 'RaceTitle' });
    if (raceTitle) {
      tournamentObj.name += ' - ' + raceTitle.Value;
    }

    const raceNumber = find(fixtureExtraData, { Name: 'RaceNumber' });
    if (
      raceNumber &&
      !raceTitle.Value.toString().includes(raceNumber.Value.toString())
    ) {
      tournamentObj.name += ' - n°' + raceNumber.Value;
    }
  }

  return {
    sport: {
      ...responsePromises[0]
    },
    category: {
      ...responsePromises[1]
    },
    tournament: {
      ...tournamentObj
    },
    // desc: {
    //     ...responsePromises[3]
    // },
    event: {
      ...responsePromises[3].events
    },
    events_sources: [...responsePromises[3].events_sources],
    // markets: {
    //     ...responsePromises[5]
    // },
    // parent: {
    //     ...responsePromises[6]
    // },
    message: {
      num_events: 1
    },
    source: source,
    type: 'antepost'
  };
}

async function refactorElement(element, rules, onlyManager, source) {
  let element_with_rules = await rulesHandler.applyRules(
    element,
    rules.manager,
    source
  );
  if (!onlyManager) {
    element_with_rules = await rulesHandler.applyRules(
      element_with_rules,
      rules.skin,
      source
    );
  }
  //console.log("element_with_rules",element_with_rules)
  const desc = await rulesHandler.getDesc(element_with_rules, rules.lang);

  return {
    id: element.id,
    _id: element._id ? element._id : false,
    source: source,
    name: desc,
    order:
      element_with_rules.order != undefined ? element_with_rules.order : 9999,
    status:
      element_with_rules.status_rule != undefined
        ? element_with_rules.status_rule
        : true
  };
}

async function refactorEventsAntepostOdds(
  event,
  rules,
  onlyManager,
  treeStructure,
  producer
) {
  let result_odds = [];
  const eventsPreviewSources = [event.id];

  if (event.odds) {
    var result_odds_fetch = await rulesHandler.applyRulesToOdds(
      event.odds,
      event.id,
      event.type,
      treeStructure,
      rules,
      onlyManager,
      producer,
      'antepost',
      'detail'
    );
    result_odds = await orderBy(
      result_odds_fetch.oddsArray,
      ['specifier_id'],
      ['asc']
    );
  } else {
    result_odds = {
      id_market: null,
      void: true
    };
  }

  return {
    events: {
      id: event.id,
      source: event.id,
      competitors: {},
      odds: { ...result_odds },
      count_odds: result_odds_fetch.count_odds,
      type: event.type,
      time: new Date(event.scheduled).getTime()
    },
    events_sources: eventsPreviewSources
  };
}

async function refactorEventsOdds(
  eventsCollections,
  rules,
  onlyManager,
  treeStructure,
  producer
) {
  const events = [];
  const eventsPreviewSources = [];

  const options = { year: 'numeric', month: 'long', day: 'numeric' };

  await Promise.all(
    eventsCollections.map(async event => {
      let status = true;
      const rules_disabled = {
        manager: filter(rules.manager, {
          type: 'disable',
          scope: 'event',
          source: event.id.toString()
        }),
        skin: filter(rules.skin, {
          type: 'disable',
          scope: 'event',
          source: event.id.toString()
        })
      };

      if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
        status = await getStatusEventFromRule(
          event.id.toString(),
          rules_disabled
        );
      }

      if (event != null && event.count > 0 && status) {
        eventsPreviewSources.push(event.id);

        let competitors = {};
        let result_odds = {};
        let description = '';

        switch (event.type) {
          case 'match':
            competitors = {
              home: {
                ...(await refactorElement(
                  event.competitors[0],
                  rules,
                  onlyManager,
                  event.competitors[0].id
                ))
              },
              away: {
                ...(await refactorElement(
                  event.competitors[1],
                  rules,
                  onlyManager,
                  event.competitors[1].id
                ))
              }
            };

            description = competitors.home.name + ' - ' + competitors.away.name;

            if (event.odds) {
              let typeOdd = event.type;

              if (typeOdd != 'antepost') {
                switch (event.sport_event_status._attributes.status) {
                  case 1: {
                    typeOdd = 'prematch';
                    break;
                  }
                  case 9: {
                    typeOdd = 'prematch';
                    break;
                  }
                  case 2: {
                    typeOdd = 'live';
                    break;
                  }
                  default: {
                    typeOdd = 'prematch';
                    break;
                  }
                }
              }

              result_odds = await rulesHandler.applyRulesToOdds(
                event.odds,
                event.id,
                event.type,
                treeStructure,
                rules,
                onlyManager,
                producer,
                typeOdd
              );
            } else {
              result_odds = {
                id_market: null,
                void: true
              };
            }
            break;

          case 'stage':
          case 'season':
          case 'simple:tournament':
            // var desc_parent = find(event.parent, {'lang': lang});
            // if (!desc_parent) {
            //     desc_parent = find(event.parent, {'lang': 'en'});
            // }
            //
            // var desc_event = find(event.detail, {'lang': lang});
            // if (!desc_event) {
            //     desc_event = find(event.detail, {'lang': 'en'});
            // }
            //
            // let d_parent = (desc_parent) ? desc_parent.text : 'Parent Detail non presente';
            // let d_event = (desc_event) ? desc_event.text : 'Event Detail non presente';
            //
            // description = d_parent + ' - ' + d_event;
            //
            // oddsArray = {
            //     id_market: null,
            //     void: true
            // }

            break;
        }

        const single_event = {
          id: event.id,
          scheduled: event.scheduled,
          day: new Date(event.scheduled).toLocaleDateString(
            rules.lang,
            options
          ),
          time: new Date(event.scheduled).getTime(),
          status: has(event, 'sport_event_status')
            ? event.sport_event_status._attributes.status
            : 0,
          competitors: competitors,
          odds: { ...result_odds.oddsArray },
          type: event.type,
          description: description,
          count_odds: event.count - result_odds.count_odds,
          livescore: event.livescore,
          quickbet: event.quickbet,
          evidence: event.evidence !== undefined ? event.evidence : 0
        };

        events.push(single_event);
      }
    })
  );

  events.sort(function (a, b) {
    return new Date(a.scheduled) - new Date(b.scheduled);
  });

  return {
    events: events,
    events_sources: eventsPreviewSources
  };
}

async function refactorEventDetailOdds(
  event,
  rules,
  onlyManager,
  treeStructure,
  producer,
  periods
) {
  const events = [];
  const eventsPreviewSources = [];

  const options = { year: 'numeric', month: 'long', day: 'numeric' };

  if (event != null) {
    const rules_disabled = {
      manager: filter(rules.manager, {
        type: 'disable',
        scope: 'event',
        source: event.id
      }),
      skin: filter(rules.skin, {
        type: 'disable',
        scope: 'event',
        source: event.id
      })
    };

    eventsPreviewSources.push(event.id);

    let competitors = {};
    let result_odds = {};
    let description = '';

    switch (event.type) {
      case 'match':
        competitors = {
          home: {
            ...(await refactorElement(
              event.competitors[0],
              rules,
              onlyManager,
              event.competitors[0].id
            ))
          },
          away: {
            ...(await refactorElement(
              event.competitors[1],
              rules,
              onlyManager,
              event.competitors[1].id
            ))
          }
        };

        description = competitors.home.name + ' - ' + competitors.away.name;

        if (event.odds) {
          var typeOdd = event.type;

          if (typeOdd != 'antepost') {
            switch (event.sport_event_status._attributes.status) {
              case 1: {
                typeOdd = 'prematch';
                break;
              }
              case 2: {
                typeOdd = 'live';
                break;
              }
              default: {
                typeOdd = 'prematch';
                break;
              }
            }
          }

          result_odds = await rulesHandler.applyRulesToOdds(
            event.odds[0].markets,
            event.id,
            event.type,
            treeStructure,
            rules,
            onlyManager,
            producer,
            typeOdd,
            'detail'
          );
        } else {
          result_odds = {
            id_market: null,
            void: true
          };
        }
        break;
    }

    if (typeOdd == 'live') {
      const currentPeriod = event.livescore.Scoreboard.CurrentPeriod;
      if (currentPeriod) {
        const detail = find(periods, { source: +currentPeriod });
        if (detail) {
          event.livescore.Scoreboard.CurrentPeriod = detail.detail;
        }
      }
    }

    const single_event = {
      id: event.id,
      source: event.id,
      // name: desc_season,
      scheduled: event.scheduled,
      day: new Date(event.scheduled).toLocaleDateString(rules.lang, options),
      time: new Date(event.scheduled).getTime(),
      // tournament_around: event.tournament_around,
      // odds: event.odds
      // status: status,
      competitors: competitors,
      odds: { ...result_odds.oddsArray },
      type: event.type,
      description: description,
      count_odds: result_odds.count_odds,
      livescore: typeOdd == 'live' ? event.livescore : {},
      quickbet: event.quickbet
    };

    events.push(single_event);
  }

  return {
    events: events,
    events_sources: eventsPreviewSources
  };
}

async function refactorMarkets(marketObj, lang) {
  const market_results = [];

  const specifiers = orderBy(marketObj.specifiers, ['sort']);

  await Promise.all(
    specifiers.map(async single_market => {
      let desc_market = find(single_market.detail, { lang: lang });

      if (!desc_market) {
        desc_market = find(single_market.detail, { lang: 'en' });
      }

      if (single_market.specifiers != '') {
        single_market.specifiers;
      }

      const outcomes = [];

      await Promise.all(
        single_market.outcomes.map(async outcomeObj => {
          const outcome = await refactorOutcome(outcomeObj, lang);
          outcomes.push(outcome);
        })
      );

      const singleMarket = {
        id: single_market.id,
        name:
          single_market.specifiers != ''
            ? desc_market.text + ' ' + single_market.specifiers
            : desc_market.text,
        outcomes: outcomes,
        specifiers:
          single_market.specifiers != '' ? single_market.specifiers : ''
      };

      market_results.push(singleMarket);
    })
  );

  return market_results;
}

async function refactorGroupMarkets(groupMarketObj, lang) {
  const groupMarkets = [];
  await Promise.all(
    groupMarketObj.map(async (single_group, index) => {
      let desc_group = find(single_group.name, { lang: lang });
      if (!desc_group) {
        desc_group = find(single_group.name, { lang: 'en' });
      }

      groupMarkets.push({ name: desc_group.text, group_id: index });
    })
  );

  return groupMarkets;
}

async function refactorOutcome(outcome, lang) {
  // var desc_outcome = find(outcome.name, {'lang': lang});
  // if (!desc_outcome) {
  //     desc_outcome = find(outcome.name, {'lang': 'en'});
  // }
  //
  // var name = desc_outcome.name.replace("{$competitor1}", "1");
  // name = name.replace("{$competitor2}", "2");
  // name = name.replace("draw", "X");
  // name = name.replace("pareggio", "X");
  // name = name.replace("empate", "X");
  // name = name.replace("Match nul", "X");
  // name = name.replace("平局", "X");

  return { id: outcome.id, name: outcome.name, sort: outcome.sort };
}

async function checkEventsPreview(preview, source) {}

async function getStatusEventFromRule(source, rules) {
  const rules_disabled = {
    manager:
      rules.manager.length > 0
        ? find(rules.manager[0].detail, { scope: 'event' })
        : undefined,
    skin:
      rules.skin.length > 0
        ? find(rules.skin[0].detail, { scope: 'event' })
        : undefined
  };

  if (rules_disabled.manager == undefined && rules_disabled.skin == undefined) {
    return true;
  } else {
    let status = true;

    if (rules_disabled.manager) {
      status = !rules_disabled.manager.status;
    }
    if (rules_disabled.skin) {
      status = !rules_disabled.skin.status;
    }
    return status;
  }
}

async function refactorNextEvents(
  dataAll,
  rules,
  producer,
  onlyManager,
  group = true
) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = find(dataAll, { selected: true });
      const eventsObj = data.events;
      const marketsObj = data.settings;

      const promise = [];
      forEachLodash(eventsObj, async event => {
        promise.push(
          refactorSingleNextEvent(
            event,
            rules,
            producer,
            onlyManager,
            marketsObj
          )
        );
      });

      const refactored = [];
      await Promise.all(promise).then(result => {
        const clean_events = filter(result, function (o) {
          return o != false;
        });

        if (group) {
          const groupedByTournament = groupBy(clean_events, obj => {
            return obj.tournament.id;
          });

          forEachLodash(groupedByTournament, (tourn, index) => {
            const events = [];
            const events_sources = [];

            forEachLodash(tourn, event => {
              events.push(event.events[0]);
              events_sources.push(event.events_sources[0]);
            });

            const object = {
              category: tourn[0].category,
              markets: tourn[0].markets,
              markets_count: tourn[0].markets_count,
              sport: tourn[0].sport,
              tournament: tourn[0].tournament,
              type: tourn[0].type,
              events: events,
              events_sources: events_sources,
              events_count: events_sources.length
            };

            refactored.push(object);
          });

          resolve(refactored);
        } else {
          resolve(clean_events);
        }
      });
    } catch (e) {}
  });
}

async function refactorEventsDay(
  dataAll,
  rules,
  producer,
  onlyManager,
  group = true,
  headerSign = null
) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = find(dataAll, { selected: true });

      const eventsObj = data.events;
      const marketsObj = data.settings;

      const promise = [];
      forEachLodash(eventsObj, async event => {
        promise.push(
          refactorSingleEventDay(
            event,
            rules,
            producer,
            onlyManager,
            marketsObj,
            headerSign
          )
        );
      });

      const refactored = [];
      await Promise.all(promise).then(result => {
        const clean_events = filter(result, function (o) {
          return o != false;
        });

        if (group) {
          const groupedByTournament = groupBy(clean_events, obj => {
            return obj.tournament.id;
          });

          forEachLodash(groupedByTournament, (tourn, index) => {
            const events = [];
            const events_sources = [];

            forEachLodash(tourn, event => {
              events.push(event.events[0]);
              events_sources.push(event.events_sources[0]);
            });

            const object = {
              category: tourn[0].category,
              markets: tourn[0].markets,
              markets_count: tourn[0].markets_count,
              sport: tourn[0].sport,
              tournament: tourn[0].tournament,
              type: tourn[0].type,
              events: events,
              events_sources: events_sources,
              events_count: events_sources.length
            };

            refactored.push(object);
          });

          resolve(refactored);
        } else {
          resolve(clean_events);
        }
      });
    } catch (e) {}
  });
}

async function refactorEventsBestPlayed(
  dataAll,
  rules,
  producer,
  onlyManager,
  group = true,
  headerSign = null
) {
  return new Promise(async (resolve, reject) => {
    try {
      const data = find(dataAll, { selected: true });
      const eventsObj = data.events;
      const marketsObj = data.settings;

      // console.log('Events: ' + _.size(eventsObj))

      const promise = [];
      forEachLodash(eventsObj, async event => {
        promise.push(
          refactorSingleEventsBestPlayed(
            event,
            rules,
            producer,
            onlyManager,
            marketsObj,
            headerSign
          )
        );
      });

      const refactored = [];
      await Promise.all(promise).then(result => {
        const clean_events = filter(result, function (o) {
          return o != false;
        });

        // console.log('Events: ' + _.size(clean_events))

        resolve(clean_events);
      });
    } catch (e) {}
  });
}

async function refactorQuickBet(data, rules, producer, onlyManager, source) {
  const eventObj = data.events;
  const sportObj = data.events.sport;
  const categoryObj = data.events.category;
  const tournamentObj = data.events.tournament;

  const tree_structure = {
    sport: sportObj.id,
    category: categoryObj.id,
    tournament: tournamentObj.id
  };

  tree_structure.treeMultiplicity = await rulesHandler.getTreeMultiplicity(
    tree_structure,
    rules,
    onlyManager,
    producer
  );

  const sport_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      sportObj,
      rules,
      onlyManager,
      sportObj.id
    );
    resolve(result);
  });

  const category_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      categoryObj,
      rules,
      onlyManager,
      categoryObj.id
    );
    resolve(result);
  });

  const tournament_promise = new Promise(async (resolve, reject) => {
    const result = await refactorElement(
      tournamentObj,
      rules,
      onlyManager,
      tournamentObj.id
    );
    resolve(result);
  });

  const event_promise = new Promise(async (resolve, reject) => {
    const result = await refactorEventQuickBetOdds(
      eventObj,
      rules,
      onlyManager,
      tree_structure,
      producer
    );
    resolve(result);
  });

  const responsePromises = await Promise.all([
    sport_promise,
    category_promise,
    tournament_promise,
    event_promise
  ]);

  return {
    sport: {
      ...responsePromises[0]
    },
    category: {
      ...responsePromises[1]
    },
    tournament: {
      ...responsePromises[2]
    },
    event: {
      ...responsePromises[3]
    },
    source: responsePromises[3].id
  };
}

async function getResult(result, team) {
  if (team == 'home') {
    var point = find(result, { Position: '1' });
    return point ? +point.Value : 0;
  } else if (team == 'away') {
    var point = find(result, { Position: '2' });
    return point ? +point.Value : 0;
  } else {
    return 0;
  }
}

async function refactorEventQuickBetOdds(
  event,
  rules,
  onlyManager,
  treeStructure,
  producer
) {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  let single_event = {};

  if (event != null) {
    //console.log(rules)
    const rules_disabled = {
      manager: filter(rules.manager, {
        type: 'disable',
        scope: 'event',
        source: _.toString(event.id)
      }),
      skin: filter(rules.skin, {
        type: 'disable',
        scope: 'event',
        source: _.toString(event.id)
      })
    };

    let status;
    if (rules_disabled.manager.length > 0 || rules_disabled.skin.length > 0) {
      //         console.log(event.id.toString(), rules_disabled)
      status = await getStatusEventFromRule(
        event.id.toString(),
        rules_disabled
      );
      //console.log("status",status)
      //status= true
    } else {
      status = true;
    }
    let competitors = {};
    let result_odds = {};
    let description = '';

    switch (event.type) {
      case 'match':
        competitors = {
          home: {
            ...(await refactorElement(
              event.competitors[0],
              rules,
              onlyManager,
              event.competitors[0].id
            ))
          },
          away: {
            ...(await refactorElement(
              event.competitors[1],
              rules,
              onlyManager,
              event.competitors[1].id
            ))
          }
        };

        description = competitors.home.name + ' - ' + competitors.away.name;

        if (event.odds) {
          var typeOdd = event.type;

          if (typeOdd != 'antepost') {
            switch (event.sport_event_status._attributes.status) {
              case 1: {
                typeOdd = 'prematch';
                break;
              }
              case 2: {
                typeOdd = 'live';
                break;
              }
              default: {
                typeOdd = 'prematch';
                break;
              }
            }
          }

          result_odds = await rulesHandler.applyRulesToOdds(
            event.odds,
            event.id,
            event.type,
            treeStructure,
            rules,
            onlyManager,
            producer,
            typeOdd,
            'detail'
          );
        } else {
          result_odds = {
            id_market: null,
            void: true
          };
        }
        break;
    }

    single_event = {
      id: event.id,
      source: event.id,
      // name: desc_season,
      scheduled: event.scheduled,
      day: new Date(event.scheduled).toLocaleDateString(rules.lang, options),
      time: new Date(event.scheduled).getTime(),
      // tournament_around: event.tournament_around,
      // odds: event.odds
      status: status,
      competitors: competitors,
      odds: { ...result_odds.oddsArray },
      type: event.type,
      description: description,
      count_odds: result_odds.count_odds,
      livescore: typeOdd == 'live' ? event.livescore : {},
      quickbet: event.quickbet
    };
  }
  return single_event;
}

async function refactorPreviewV2(
  data,
  sport,
  category,
  tournament,
  producer,
  onlyManager,
  source
) {
  let headerSign = data.headerSign != null ? data.headerSign : null;

  return {
    sport: {
      ...sport
    },
    category: {
      ...category
    },
    tournament: {
      ...tournament
    },
    events: {
      ...data.events
    },
    source: source,
    type: 'prematch',
    headerSign: headerSign
  };
}

export default {
  refactorNextEvents,
  refactorEventsDay,
  refactorEventsBestPlayed,
  refactorLive,
  refactorSingleLive,
  refactorPreview,
  refactorPreviewAntepost,
  refactorDetail,
  refactorOddsDetail,
  refactorQuickBet,
  refactorPreviewV2,
  getResult
};
